import { useEffect } from 'react';
import { useRequireAdmin } from '@/hooks/useRequireAdmin';
import CeoMonthlyMetricsPage from '@/pages/admin/CeoMonthlyMetricsPage';
import MetricasAvancadasPage from '@/pages/admin/MetricasAvancadasPage';

const SECTIONS = [
  { id: 'metricas-mensais', label: 'Métricas Mensais' },
  { id: 'metricas-avancadas', label: 'Métricas Avançadas' },
];

function Section({ id, title, children }) {
  return (
    <section id={id} className="scroll-mt-24" data-testid={`met-section-${id}`}>
      <div className="flex items-center gap-3 mb-3">
        <span className="w-1.5 h-6 rounded-full bg-brand-green" />
        <h2 className="font-heading font-medium text-lg text-brand-text">{title}</h2>
      </div>
      <div className="bg-brand-bg/30 border border-brand-border rounded-3xl p-4 sm:p-5">{children}</div>
    </section>
  );
}

export default function MetricasHubPage() {
  useRequireAdmin();
  useEffect(() => {
    const hash = window.location.hash?.replace('#', '');
    if (hash) { const el = document.getElementById(hash); if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 300); }
  }, []);
  const jump = (id) => { const el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth' }); };
  return (
    <div className="fade-in" data-testid="metricas-hub-page">
      <h1 className="font-heading font-medium text-xl text-brand-text mb-1">Métricas</h1>
      <div className="sticky top-0 z-20 bg-white/90 backdrop-blur-sm -mx-4 px-4 py-2 mb-5 border-b border-brand-border flex gap-2 overflow-x-auto">
        {SECTIONS.map(s => (
          <button key={s.id} onClick={() => jump(s.id)} className="whitespace-nowrap px-3 py-1.5 rounded-full text-xs font-medium bg-brand-bg text-brand-muted border border-brand-border hover:bg-brand-green/5 hover:text-brand-green" data-testid={`met-nav-${s.id}`}>{s.label}</button>
        ))}
      </div>
      <div className="space-y-10">
        <Section id="metricas-mensais" title="Métricas Mensais"><CeoMonthlyMetricsPage /></Section>
        <Section id="metricas-avancadas" title="Métricas Avançadas"><MetricasAvancadasPage /></Section>
      </div>
    </div>
  );
}
